<template>
  <div class="db-card-content db-card-content-venue">
    <!-- Title -->
    <h3
      class="db-card-title db-title-1 db-tw-cursor-pointer"
      v-on:click="$emit('click-details')"
    >
      <slot name="title" />
    </h3>
    <!-- Icons list -->
    <DbListDetailsIcons
      v-if="showRoomAttributes"
      class="db-list-details-icons-rows"
      :listLength="listIconItems.length"
      :dynamicWidth="true"
      :dynamicWidthWithCallBack="() => $emit('click-details')"
    >
      <template v-slot:type="{ index }">
        {{ listIconItems[index].type }}
      </template>
      <template v-slot:icon="{ index }">
        <component
          :is="listIconItems[index].icon"
          :width="listIconItems[index].iconSize"
          :height="listIconItems[index].iconSize"
        />
      </template>
      <template v-slot:value="{ index }">
        <slot :name="listIconItems[index].slotname" />
      </template>
    </DbListDetailsIcons>
    <!-- Description -->
    <p
      v-if="$slots.description"
      class="db-card-description"
    >
      <slot name="description" />
    </p>
    <!-- Amenities -->
    <div
      v-if="$slots.amenities"
      class="db-card-amenities"
    >
      <slot name="amenities" />
    </div>
    <!-- Details button -->
    <button
      class="db-button-text-link db-bold db-card-button-details"
      v-on:click="$emit('click-details')"
    >
      {{ $t('More details') }}
      <IconDbChevron
        class="db-rotate-180"
        width="9"
        height="9"
      />
    </button>
    <!-- Rate -->
    <div class="db-card-rate db-text-right">
      <slot name="rate" />
    </div>
    <!-- Select button -->
    <button
      type="button"
      class="db-button-large db-button-primary db-card-button-select"
      v-on:click="$emit('select-item')"
    >
      {{ $t('Select this venue') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import IconDbDimensions from '~icons/db/dimensions'
import IconDbMaxCapacity from '~icons/db/max-capacity'
import { useI18n } from 'vue-i18n'
import { computed, useSlots } from 'vue'

defineProps<{
  showRoomAttributes?: boolean
}>()

defineEmits<{
  (e: 'click-details'): void
  (e: 'select-item'): void
}>()

const { t } = useI18n()

const slots = useSlots()

// TODO: xo7: check the icons label
/** Infos to generate the list of icons */
const listIconItems = computed(() => {
  return [
    { type: t('Dimensions'), icon: IconDbDimensions, iconSize: 22, slotname: 'dimensions' },
    { type: t('Capacity'), icon: IconDbMaxCapacity, iconSize: 22, slotname: 'capacity' },
  ].filter((el) => {
    return slots?.[el.slotname] && slots?.[el.slotname]()[0]
  })
})
</script>

<style scoped>
/* General infos */
.db-app .db-card-content-venue :deep(.db-list-details-icons) {
  font-size: var(--db_small_body_text_font_size);
}

.db-app .db-card-content-venue :deep(.db-list-details-icons) {
  gap: var(--db-spacer-10);
}

.db-app .db-card-content-venue :deep(.db-list-details-icons) {
  display: flex;
  flex-wrap: wrap;
  column-gap: var(--db-spacer-6);
  row-gap: var(--db-spacer-8);
}

.db-app .db-card-content-venue .db-list-details-icons-rows {
  grid-auto-columns: max-content;
  grid-gap: var(--db-spacer-6);
}

.db-app .db-card-content-venue .db-card-title {
  font-size: var(--db_title_3_font_size) !important;
}

.db-app .db-card-content-venue .db-card-description:empty,
.db-app .db-card-content-venue .db-card-amenities:empty {
  display: none;
}

/* Mobile spacing */
.db-app .db-card-content-venue :deep(.db-list-details-icons),
.db-app .db-card-content-venue .db-card-description,
.db-app .db-card-content-venue .db-card-amenities {
  margin-top: var(--db-spacer-1);
}
.db-app .db-card-content-venue .db-card-button-details {
  margin-top: var(--db-spacer-4);
  font-style: var(--db_link_font_style);
}
.db-app .db-card-content-venue .db-card-rate {
  margin-top: var(--db-spacer-32);
}
.db-app .db-card-content-venue :deep(.db-card-list-amenities) {
  margin-top: var(--db-spacer-8);
  gap: var(--db-spacer-20);
}

.db-app .db-card-content-venue .db-card-rate :deep(.db-spinner) {
  margin-bottom: var(--db-spacer-12);
}

@media screen and (min-width: 992px) {
  .db-app .db-card-content-venue :deep(.db-list-details-icons) {
    margin-top: var(--db-spacer-16);
  }
  .db-app .db-card-content-venue .db-card-description {
    margin-top: var(--db-spacer-18);
  }
  .db-app .db-card-content-venue .db-card-rate {
    grid-row: 2 / span 3;
    margin-top: var(--db-spacer-20);
  }

  .db-app .db-card-content-venue .db-card-button-select {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    align-self: flex-end !important;
  }

  .db-app .db-card-content-venue .db-card-title {
    font-size: var(--db_title_1_font_size) !important;
  }
}
</style>
